'use strict'

module.exports = {
    videoPosterPrefix: '', // video poster not in use (deprecated)
    videoSrcPrefix: 'addpanel/transparent-video/v1/videobox-thumb-'
}
